export default __webpack_public_path__ + "static/media/a00f9d5fe3e59fef.9cfe9cbfbed4cb4b95ad086e3dc94acd.svg";